import React, { useEffect, useMemo, useState } from "react";
import "./CompareLayersSidebar.css";

const LAYER_LABEL_OVERRIDES = {
    trafo_stanice: "Trafostanice",
    trafo_stanica: "Trafostanica",

    mjerna_mjesta: "Mjerna mjesta",
    mjerno_mjesto: "Mjerno mjesto",

    ocitacki_hod: "Očitački hod",
    ocitacki_hodovi: "Očitački hodovi",

    stubovi: "Stubovi",
    stub: "Stub",

    vod: "Dalekovodi",
    vodovi: "Dalekovodi",
    dalekovod: "Dalekovod",
    dalekovodi: "Dalekovodi",
};

const toTitleCase = (text = "") =>
    text
        .toLowerCase()
        .split(" ")
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

const cleanLayerName = (id = "") => {
    const rawName = id
        .replace(/-layer$/i, "")
        .replace(/^wfs[-_:]/i, "")
        .replace(/^pgsql[-_:]/i, "")
        .replace(/^elektro:/i, "")
        .replace(/^GeoSolution:/i, "")
        .trim();

    const normalizedKey = rawName
        .replace(/-/g, "_")
        .replace(/\s+/g, "_")
        .toLowerCase();

    if (LAYER_LABEL_OVERRIDES[normalizedKey]) {
        return LAYER_LABEL_OVERRIDES[normalizedKey];
    }

    return toTitleCase(rawName.replace(/_/g, " "));
};

const getLayerLabel = (layer) =>
    layer?.props?.displayName ||
    layer?.props?.name ||
    layer?.props?.title ||
    layer?.props?.layerName ||
    cleanLayerName(layer?.id);

const CompareLayersSidebar = ({
    wfsLayers,
    setCheck,
    handleToggleCompare,
    isCompareMode,
}) => {
    const [checkedLayers, setCheckedLayers] = useState([]);
    const [alertMessage, setAlertMessage] = useState("");

    const comparableLayers = useMemo(
        () =>
            (wfsLayers || []).filter(
                (layer) => !String(layer?.id || "").toLowerCase().includes("dionica")
            ),
        [wfsLayers]
    );

    useEffect(() => {
        const existingIds = new Set(comparableLayers.map((layer) => layer.id));

        setCheckedLayers((prev) =>
            prev.filter((id) => existingIds.has(id))
        );
    }, [comparableLayers]);

    useEffect(() => {
        setCheck(comparableLayers.filter((layer) => checkedLayers.includes(layer.id)));
    }, [checkedLayers, comparableLayers, setCheck]);

    const handleCheck = (layer) => {
        setCheckedLayers((prev) => {
            if (prev.includes(layer.id)) {
                return prev.filter((id) => id !== layer.id);
            }

            if (prev.length >= 2) {
                setAlertMessage("Možete čekirati maksimalno dva sloja.");
                setTimeout(() => setAlertMessage(""), 3000);
                return prev;
            }

            return [...prev, layer.id];
        });
    };

    const handleCompareToggle = () => {
        if (isCompareMode) {
            setCheckedLayers([]);
        }

        handleToggleCompare();
    };

    return (
        <div className="compare-panel">
            {comparableLayers.map((layer) => (
                <div key={layer.id}>
                    <label className={checkedLayers.includes(layer.id) ? "checked" : ""}>
                        <input
                            type="checkbox"
                            checked={checkedLayers.includes(layer.id)}
                            onChange={() => handleCheck(layer)}
                            disabled={!checkedLayers.includes(layer.id) && checkedLayers.length >= 2}
                        />

                        <span>{getLayerLabel(layer)}</span>
                    </label>
                </div>
            ))}

            {comparableLayers.length < 2 && (
                <div className="warning-message">
                    Potrebno je minimum dva sloja za poređenje.
                </div>
            )}

            <button
                className="compare-button"
                onClick={handleCompareToggle}
                disabled={!isCompareMode && checkedLayers.length !== 2}
            >
                {isCompareMode ? "Zaustavi poređenje" : "Pokreni poređenje"}
            </button>

            {alertMessage && <div className="custom-alert">{alertMessage}</div>}
        </div>
    );
};

export default CompareLayersSidebar;